export const updateToolCall = (llmRequestRefs: any, messageId: string, updateData: any) => {
    llmRequestRefs.current.toolCalls[messageId] = {
        ...llmRequestRefs.current.toolCalls[messageId],
        ...updateData
    };

    const toolCallIndex = llmRequestRefs.current.aiMessage.message.tool_calls.findIndex(
        (toolCall: any) => toolCall.id === messageId
    );

    if (toolCallIndex !== -1) {
        llmRequestRefs.current.aiMessage.message.tool_calls[toolCallIndex] = {
            ...llmRequestRefs.current.aiMessage.message.tool_calls[toolCallIndex],
            ...updateData
        };
    }
};